import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	backItem: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.other.back-item',
		defaultMessage: 'Back to reports',
		description: 'Back to reports item',
	},
	other: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.other.other',
		defaultMessage: 'Other',
		description: 'Other links group title',
	},
	workloadPieChart: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.other.workload-pie-chart',
		defaultMessage: 'Workload Pie Chart Report',
		description: 'Workload pie chart report link item',
	},
});
